// UserContext.js
import { createContext, useContext } from 'react';

export const UserContext = createContext(null);

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children, user }) => (
  <UserContext.Provider value={{ user }}>
    {children}
  </UserContext.Provider>
);
